import $ from 'jquery';

$(document).ready(function() {
    let navToggle = false;

    $('#hamburger').on('click', e => {
        $('#hamburger').toggleClass('is-active');
        $('body').toggleClass('locked-mobile-nav');
        $('#site-nav').toggleClass('active');
        $('.body-overlay').toggleClass('active-nav-mobile');
    
        // check for window resize. If resize is greater than 1000px, close the mobile nav
        if (!navToggle) {
            const resizeListener = () => {
                if (window.innerWidth > 1280) {
                    closeNav();
        
                    $(window).off('resize', resizeListener); 
                }
            };

            $(window).on('resize', resizeListener);
        }

        navToggle = true;
    });
    
    // open sub nav items
    $('.open-nav-click').on('click', e => {
        console.log('open-nav-click');

        if (window.innerWidth <= 1280) {
            const parent = e.target.closest('li');
            console.log('working');
            console.log(parent);
    
            parent.querySelector('.sub-menu-wrapper').classList.add('active');
        }
    });
    
    // close sub nav items
    $('.close-nav-click').on('click', e => {
        if (window.innerWidth <= 1280) {
            const parent = e.target.closest('.sub-menu-wrapper');
    
            parent.classList.remove('active');
        }
    });
    
    // close mobile nav if clicking outside of the navigation
    $('.body-overlay').on('click', e => closeNav());
    
    // reuseable close nav function
    function closeNav (e) {
        $('#hamburger').removeClass('is-active');
        $('body').removeClass('locked-mobile-nav');
        $('#site-nav').removeClass('active');
        $('.body-overlay').removeClass('active-nav-mobile');

        navToggle = false;
    }
});


